function hexToRgb(hex) {
  // 去除#号
  hex = hex.replace(/^#/, '');

  // 处理缩写形式如 #abc
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  // 转换为RGB
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  return { r, g, b };
}

function rgbToHue(r, g, b) {
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let hue = 0;

  if (max === min) {
    hue = 0; // 无色
  } else {
    const delta = max - min;
    switch (max) {
      case r:
        hue = (g - b) / delta + (g < b ? 6 : 0);
        break;
      case g:
        hue = (b - r) / delta + 2;
        break;
      case b:
        hue = (r - g) / delta + 4;
        break;
    }
    hue /= 6;
  }

  return Math.round(hue * 360); // 转换为0-360度
}

export enum ColorCategory {
  Red = 'red',
  Orange = 'orange',
  Yellow = 'yellow',
  Green = 'green',
  Cyan = 'cyan',
  Blue = 'blue',
  Purple = 'purple',
  Unknown = 'unknown',
}

export const imageMap = {
  [ColorCategory.Red]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i3/O1CN01cZmHSL23QYVl8KMrF_!!6000000007250-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i2/O1CN016nQyGT1K3VuFlqYwk_!!6000000001108-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i4/O1CN01kUZ8En1dpaArCxJr2_!!6000000003785-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i2/O1CN01rDl5IG25juVj6HvEx_!!6000000007563-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i4/O1CN01XhdzPz1mvNjPbRezX_!!6000000005016-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i2/O1CN01N9EQVk1OxctT02I8M_!!6000000001772-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01vuqcJz1o9rsHEkSKU_!!6000000005183-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i2/O1CN0108CogD1i6lUonK4vI_!!6000000004364-2-tps-341-372.png',
  },
  [ColorCategory.Orange]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i4/O1CN01Fn3crp25mer9FW4hJ_!!6000000007569-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i1/O1CN01juU90a278TMorZqFe_!!6000000007752-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i4/O1CN01NkJuxI29uDtKCs15E_!!6000000008127-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i2/O1CN01Swxttu1W7QgHyjHib_!!6000000002741-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i4/O1CN01DJAcLC20pL7vdOZLz_!!6000000006898-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i2/O1CN011bCNvC1TiZxYRYCyY_!!6000000002416-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01j2qp0v22QGg3H7DRl_!!6000000007114-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i4/O1CN01DmGZrt1QnfVvlMngJ_!!6000000002021-2-tps-341-372.png',
  },
  [ColorCategory.Yellow]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i2/O1CN01Fjnbjd1qyp8dkvbJT_!!6000000005565-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i3/O1CN01vBQP6m28Xx124JS5k_!!6000000007943-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i2/O1CN01oEjLPM1arvLt4nQH0_!!6000000003384-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i4/O1CN01S7ZbvO24FqtuvsnVL_!!6000000007362-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i2/O1CN014E27aG239bt6U1MF2_!!6000000007213-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i2/O1CN01af4u8X1JfhJKFj6pH_!!6000000001056-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01mpOWUq1MSp1UjqfKJ_!!6000000001434-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i1/O1CN01xm0BWC1j3qaZEQAn2_!!6000000004493-2-tps-341-372.png',
  },
  [ColorCategory.Green]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i2/O1CN01XqSnHA28tvzp0nu9E_!!6000000007991-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i4/O1CN01l1AscZ1ZKeyDS3aU3_!!6000000003176-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i2/O1CN01HtsVyR1sTLB0jgViQ_!!6000000005767-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i3/O1CN01dqfhFR24E1JihTw63_!!6000000007358-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i3/O1CN01fDEDgJ1FnhlvW0xei_!!6000000000532-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i1/O1CN01O1Z8nU26GQdCHYvTH_!!6000000007634-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i1/O1CN01SJUJ2R1cAzSGzkHQC_!!6000000003561-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i2/O1CN01elytIi1IT2kfeoft2_!!6000000000893-2-tps-341-372.png',
  },
  [ColorCategory.Cyan]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i4/O1CN01Ign0W023OGWzHaFOn_!!6000000007245-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i4/O1CN01aU4NFx1KXk2vZ3UxM_!!6000000001174-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i4/O1CN01WQNvZQ1VnHFk50b9s_!!6000000002697-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i1/O1CN01lvqRhT1DyZwYqDxsw_!!6000000000285-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i3/O1CN01JeYaQQ1s1rPe7ru38_!!6000000005707-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i4/O1CN01tkEpTQ27e4h5RmzIs_!!6000000007821-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01p17L8E1F3uAIrdeUD_!!6000000000432-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i2/O1CN016ypMyH1orptc95Epw_!!6000000005279-2-tps-341-372.png',
  },
  [ColorCategory.Blue]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i3/O1CN01UVPATp1SPyDo7cldC_!!6000000002240-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i3/O1CN01ZlErmK27hjreyZ7Dj_!!6000000007829-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i4/O1CN01L4ocE01aYgiUZ44GE_!!6000000003342-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i2/O1CN01c3oDLT1xnYjvoWafk_!!6000000006488-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i4/O1CN01YeFZXd1WvLqtOd4uJ_!!6000000002850-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i3/O1CN01WbRvRX1VVsCjfmFlK_!!6000000002659-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01NQY5sX1kpldzrL2U0_!!6000000004733-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i3/O1CN01KUNY1k1ckiLgz4f5W_!!6000000003639-2-tps-341-372.png',
  },
  [ColorCategory.Purple]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i3/O1CN01dBLP9W1qokQPGgQ3s_!!6000000005543-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i4/O1CN01GmCKTb1jJQ3TfihoL_!!6000000004527-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i4/O1CN0123aHGz22zzZOQaj2F_!!6000000007192-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i3/O1CN018xppm11LOrzSrxp8y_!!6000000001290-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i4/O1CN01aq3V8W1DFEjXfsztj_!!6000000000186-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i4/O1CN01GBnHyf1SyJxOlhlqa_!!6000000002315-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01hv5Gee27sjMyi9VHt_!!6000000007853-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i4/O1CN01US1znj1ubFF3Kl71M_!!6000000006055-2-tps-341-372.png',
  },
  [ColorCategory.Unknown]: {
    loginBg:
      'https://img.alicdn.com/imgextra/i3/O1CN01UVPATp1SPyDo7cldC_!!6000000002240-2-tps-3372-2248.png',
    homeStep01:
      'https://gw.alicdn.com/imgextra/i3/O1CN01ZlErmK27hjreyZ7Dj_!!6000000007829-2-tps-341-372.png',
    homeStep02:
      'https://gw.alicdn.com/imgextra/i4/O1CN01L4ocE01aYgiUZ44GE_!!6000000003342-2-tps-341-372.png',
    homeStep03:
      'https://gw.alicdn.com/imgextra/i2/O1CN01c3oDLT1xnYjvoWafk_!!6000000006488-2-tps-341-372.png',
    homeStep04:
      'https://gw.alicdn.com/imgextra/i4/O1CN01YeFZXd1WvLqtOd4uJ_!!6000000002850-2-tps-341-372.png',
    homeStep05:
      'https://gw.alicdn.com/imgextra/i3/O1CN01WbRvRX1VVsCjfmFlK_!!6000000002659-2-tps-341-372.png',
    homeStep06:
      'https://gw.alicdn.com/imgextra/i3/O1CN01NQY5sX1kpldzrL2U0_!!6000000004733-2-tps-341-372.png',
    homeStep07:
      'https://gw.alicdn.com/imgextra/i3/O1CN01KUNY1k1ckiLgz4f5W_!!6000000003639-2-tps-341-372.png',
  },
};

export function getColorCategory(hex) {
  const { r, g, b } = hexToRgb(hex);
  const hue = rgbToHue(r, g, b);
  if (hue < 15 || hue >= 345) {
    return ColorCategory.Red;
  } else if (hue >= 15 && hue < 40) {
    return ColorCategory.Orange;
  } else if (hue >= 40 && hue < 75) {
    return ColorCategory.Yellow;
  } else if (hue >= 75 && hue < 165) {
    return ColorCategory.Green;
  } else if (hue >= 165 && hue < 220) {
    return ColorCategory.Cyan;
  } else if (hue >= 220 && hue < 245) {
    return ColorCategory.Blue;
  } else if (hue >= 245 && hue < 345) {
    return ColorCategory.Purple;
  } else {
    return ColorCategory.Unknown;
  }
}

export function getImages() {
  const currentPrimaryColor = window.__SUPERAPP_CONFIG__?.themeColors?.primary1 || '#2561F5';
  const colorCategory = getColorCategory(currentPrimaryColor);
  return imageMap[colorCategory];
}
